var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgK8SNode = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 6.5H6a1 1 0 0 0-1 1V14a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V7.5a1 1 0 0 0-1-1m0 1V9H6V7.5zm0 2.5v1.5H6V10zm-4 4v-1.5h4V14z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.955 5.065a.06.06 0 0 1-.048-.048 5 5 0 0 0-3.962-3.926 5 5 0 0 0-5.852 3.926.06.06 0 0 1-.048.048 3.751 3.751 0 0 0 .7 7.435H4v-1h-.252a2.756 2.756 0 0 1-2.72-3.15 2.85 2.85 0 0 1 2.357-2.33l.509-.092a.07.07 0 0 0 .052-.052l.09-.467a4.14 4.14 0 0 1 3.423-3.372 4 4 0 0 1 1.424.063 4.11 4.11 0 0 1 3.074 3.272l.097.504a.065.065 0 0 0 .052.052l.529.096c.583.092 1.124.36 1.55.77a2.753 2.753 0 0 1-1.931 4.706H12v1h.254a3.75 3.75 0 0 0 .701-7.435"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgK8SNode;